import type { Facility } from "@shared/schema";
import { FacilityPartiesPanel } from "../../facility-parties-panel";

interface FacilityPartiesTabProps {
  facility: Facility;
  dealId: string;
  clientGroupId?: string;
}

export function FacilityPartiesTab({ facility, dealId, clientGroupId }: FacilityPartiesTabProps) {
  return (
    <div className="space-y-3">
      <FacilityPartiesPanel
        facilityId={facility.id}
        clientGroupId={clientGroupId}
        dealId={dealId}
      />
    </div>
  );
}
